export default {
  computed: {
    cashPort() {
      const user = localStorage.getItem('terminal_department') 
      if (!user)
        return 'COM3'
      return JSON.parse(user).terminal.cash_port  
    }
  }  
}